module.exports = __webpack_public_path__ + "public/adminIcons/mangePayoutIcon.svg?7efde6ee";